import { render } from "./LoadingButton.vue?vue&type=template&id=646c50b8"
import script from "./LoadingButton.vue?vue&type=script&lang=js"
export * from "./LoadingButton.vue?vue&type=script&lang=js"

import exportComponent from "/src/Hikarusa.Webapp/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__